import { CommonUtilities } from '../../commonUtils';

export default class TransactionServices {

    static projectStatement(param: any) {
        var url = 'contract/statement/project/list?' + CommonUtilities.buildQueryString(param, true, true)
        return CommonUtilities.getData(url);
    }

    static savePayment = function (period: any, type: any, postData: any, hold: any, payOpeningBalance: any) {
        if (!payOpeningBalance) {
            payOpeningBalance = false;
        }
        var url = 'contracts/savePayment/' + period + '?paymentType=' + type + '&hold=' + hold + '&payOpeningBalance=' + payOpeningBalance;

        console.log(postData)
        //return null ; 
        return CommonUtilities.postData(url, postData);
    };

    static history = function (param: any) {
        var url = 'salesAnalysis/invoices/costs?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    };

    //https://qa.onkorrect.com/Api/salesAnalysis/factSalesAct/Costs/KORRECT/2019Q4-%20A%2020234_52721/1/0?pageNumber=1&pageSize=10

    static factSalesActListing = function (header: any, account: any, transId: any, param: any) {
        var url = 'salesAnalysis/factSalesAct/' + header + '/' + account + '/' + transId + '/1/0?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    };

    static getItemCodeSoldTracks(param: any) {
        var url = 'salesAnalysis/factSalesAct/getItemCodeSoldTracks?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    //getItemCodeSoldContracts
    static getItemCodeSoldContracts(param: any) {
        var url = 'salesAnalysis/factSalesAct/getItemCodeSoldContracts?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    //getItemCodeSoldCompilations
    static getItemCodeSoldCompilations(param: any) {
        var url = 'salesAnalysis/factSalesAct/getItemCodeSoldCompilations?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static subDetails(param: any) {
        var url = 'salesAnalysis/factSalesAct/' + param.headerType + '/' + param.accountCode + '/' + param.transactionRef + '/1/1';
        return CommonUtilities.getData(url);
    }

    static saveDetails(param: any) {
        var url = 'salesAnalysis/factSalesAct';
        return CommonUtilities.postData(url, param);
    }





    static ReCalcOpeningBalance(param: any) {
        var url = 'contracts/savePaymentKontactInfo?';
        return CommonUtilities.postData(url, param);
    }

    static savePaymentKontactInfo(param: any) {
        var url = 'contracts/ReCalcOpeningBalance';
        return CommonUtilities.postData(url, param);
    }

    static saveStatusFlag(param: any) {
        var url = 'contracts/saveStatusFlag/20240331/' + param?.status + '/2025';
        return CommonUtilities.postData(url, param);
    }

    static getPaymentDetails(period: any, param: any) {
        var url = 'contracts/getPaymentDetails/' + period + '?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static suggestedPayments(param: any) {
        var url = 'contracts/suggestedPayments/count?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }


    static getViewAll(param: any) {
        var url = 'salesAnalysis/invoices/digital?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getInvoiceCheckDetails(param: any) {
        var url = 'salesAnalysis/invoices/checkReport/level1?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static viewAllDetils(param: any) {
        var url = 'salesAnalysis/invoices/digital/' + param.accountCode + '/' + param.invoiceNum + '/' + param.transactionRef + '/' + param.homeValue + '/' + param.currencySign + '/' + param.currencyValue + '/' + param.exchRate + '/' + param.royaltyPeriod + '/' + param.invoiceDate;
        return CommonUtilities.getData(url);
    }

    static matchingSearch(param: any) {
        var url = 'salesAnalysis/digital/20231231/searchRaw?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }



    // Transactions
    static PublishingSong(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static PublishingWriter(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static Digital(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static Physical(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static Costs(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static Advances(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static Licensing(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static Adjustments(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }


    // Publishing - Song Arena
    static Raw(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }

    static Audit(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static Publishing(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }

    //iTunes Monthly - File History Button
    static fileHistory(param: any) {
        var url = 'itunes/getFileHistory/count?'
        return CommonUtilities.getData(url);
    }


    //Youtube Reports
    static youtubeV1Reports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static youtubeV1_1Reports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static youtubeV1PublisherReports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static youtubeV1PublisherAdjReports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }

    //Youtube Red Reports
    static youtubeRedV1Reports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static youtubeRedV1_1Reports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }

    // Google Play
    static googlePlayManual(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static googlePlayAuto(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }


    // Matching Territories
    static territoryCode(param: any) {
        var url = 'contracts/territoryCode/' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static getTerritoryCode(param: any) {
        var url = 'salesAnalysis/getTerritoryAliases/' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getCodingStr(param: any) {
        var url = 'salesAnalysis/getCodingStr/' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static matchingCalatog(param: any) {
        var url = 'salesAnalysis/getFactSalesRawAccountCode/1' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static matchingSongs(param: any) {
        var url = 'salesAnalysis/getFactSalesRawAccountCode/2' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getRelAliases(param: any) {
        var url = 'salesAnalysis/getRelAliases?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getFormatAlias(param: any) {
        var url = 'salesAnalysis/getFormatAlias/' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static checkUploadYoutube(param: any) {
        var url = 'dataManagement/youtube/checkUpload?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static checkUploadYoutubeRed(param: any) {
        var url = 'dataManagement/youtube/checkUpload?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static viewYTUploadFileLog(param: any) {
        var url = 'importLog/SearchFileLog/YT/none?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static viewYRUploadFileLog(param: any) {
        var url = 'importLog/SearchFileLog/YR/none?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static viewAZUploadFileLog(param: any) {
        var url = 'importLog/SearchFileLog/AZ/none?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static viewGPUploadFileLog(param: any) {
        var url = 'importLog/SearchFileLog/GP/none?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static viewSPUploadFileLog(param: any) {
        var url = 'importLog/SearchFileLog/SP/none?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getSpotifyExchangeRate(param: any) {
        var url = 'dataManagement/spotify/getSpotifyExchangeRate/' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
}